import ModuleRedirectPage from './ModuleRedirectPage';

export default ModuleRedirectPage;
